var btn = $('#button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});






$(document).ready(function() {
    // Check if the accordion item has the 'open' class
    if ($('.accordion-item.open').length) {
        // Show the content
        $('#content1').show(); // or use slideDown() for animation
        // Update the aria-expanded attribute
        $('#heading1').attr('aria-expanded', 'true');
    }
});

